export default __webpack_public_path__ + "static/media/Raleway-Regular.9ade142e.ttf";